import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserListComponent } from './pages/user-list/user-list.component';
import { UserRoutes } from './user.routes';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';

const ROUTES: Routes = [
    { path: UserRoutes.UserList, component: UserListComponent },
    { path: UserRoutes.UserProfile, component: UserProfileComponent }
];

@NgModule({
    imports: [RouterModule.forChild(ROUTES)],
    exports: [RouterModule]
})
export class UserRoutingModule {}
